// extracted by mini-css-extract-plugin
module.exports = {"loadButton":"masonryPosts-module--loadButton--1MkkS","buttonAnimation":"masonryPosts-module--buttonAnimation--3WaGA"};